/**
 * Écran Réglages (docs/05 §3.6, F-SETTINGS-001/002/003). Rendu pur : reflète l'état de
 * `settings.ts` dans les contrôles. Les clics sont câblés dans `main.ts` (comme les autres
 * écrans). Réutilise les tokens et la topbar existants — aucun nouveau pattern.
 */
import { getSettings } from '../../settings';

const $ = (id: string): HTMLElement | null => document.getElementById(id);

const APP_NAME = 'Tuilya';

export function renderSettings(): void {
  const s = getSettings();

  const sound = $('setSound');
  if (sound) {
    sound.classList.toggle('on', s.sound);
    sound.setAttribute('aria-checked', String(s.sound));
  }

  const vol = $('setVolume') as HTMLInputElement | null;
  if (vol) {
    vol.value = String(Math.round(s.volume * 100));
    vol.disabled = !s.sound;
  }
  $('setVolRow')?.classList.toggle('off', !s.sound);

  const hap = $('setHaptics');
  if (hap) {
    hap.classList.toggle('on', s.haptics);
    hap.setAttribute('aria-checked', String(s.haptics));
  }

  const motion = $('setMotion');
  if (motion) {
    [...motion.children].forEach((b) => {
      const el = b as HTMLElement;
      el.classList.toggle('on', el.dataset.m === s.motion);
    });
  }

  const foot = $('setFoot');
  if (foot) {
    foot.textContent = `${APP_NAME} · Sans compte, tes données restent sur l'appareil`;
  }
}
